<template>
    <div>
        <template v-for="modal in modals">
            <v-dialog :value="modal.show"
                      v-bind="modal.dialog"
                      @input="dialogInput(modal,$event)"
                      :ref="'dialog_for_'+modal.id"
                      :key="modal.id">
                <component
                    :key="'comp_'+modal.id"
                    :is="modal.component"
                    :modalId="modal.id"
                    v-on="modal.on"
                    v-bind="modal.bind"
                    @modal-close="ui__closeModal(modal.id)"
                    @modal-hide="ui__hideModal(modal.id)"
                    @modal-show="ui__showModal(modal.id)"
                >

                </component>
            </v-dialog>
        </template>
    </div>
</template>

<script>

import {mapMutations} from "vuex";
import dialogs        from "../../dialogs/dialogs";
import UiManagerMixin from "../../mixins/UiManagerMixin";

export default {
    name    : "ModalContainer",
    mixins  : [UiManagerMixin],
    computed: {
        modals() {
            return this.$store.state.ui.modals;
        }
    },
    methods : {
        ...mapMutations({
            setModalVisibility: 'ui/setModalVisibility'
        }),
        dialogInput(modal,show){
            if(!modal.persist && !show) {
                this.ui__closeModal(modal.id)
            }else{
                this.setModalVisibility({id:modal.id,show:show})
            }

        }
    },
    mounted() {
        this.ui__setModalContainer(this);
        dialogs.attach(this.$store, dialogs.dialogs);
    }
}
</script>

<style scoped>

</style>
